export default {
    catalogType: [
        {text: "政策法规", value: 20},
        {text: "行业新闻", value: 21},
        {text: "项目新闻", value: 22},
        {text: "其他资讯", value: 24},
        {text: "机构新闻", value: 23},
        {text: "常规装备", value: 40},
        {text: "特殊装备", value: 41},
        {text: "其他装备", value: 42},
        {text: "队伍话题", value: 2},
    ],
    levelText: [
        {text: "一级", value: 1},
        {text: "二级", value: 2},
        {text: "三级", value: 3},
        {text: "四级", value: 4},
        {text: "五级", value: 5},
        {text: "六级", value: 6},
        {text: "七级", value: 7},
        {text: "八级", value: 8},
        {text: "九级", value: 9},
    ],
    levelTextTeacher:[
        {text: "实习", value: 1},
        {text: "初级", value: 2},
        {text: "中级", value: 3},
        {text: "高级", value: 4},
    ],
    teamType: [
        {text: "专业", value: '0'},
        {text: "社区/村", value: 1},
        {text: "机构", value: 2},
        {text: "教官", value: 3},
        {text: "管理者", value: 4},
        {text: "企业", value: 5},
        {text: "其他", value: 6},
    ],
    orderType: [
        {text: "已取消", value: '0'},
        {text: "未付款", value: 1},
        {text: "已付款", value: 2},
        {text: "已发货", value: 3},
        {text: "已完成", value: 4},
    ],
    achievementType: [
        { text: "历史成就", value: 1 },
        { text: "教官成就", value: 3 },
        { text: "队员等级", value: 2 },
        { text: "学习成就", value: 4 },
        { text: "任务成就", value: 5 },
        { text: "年度勋章", value: 6 }
    ],
    hasCertification:[
        { text: "未认证", value: '0' },
        { text: "认证中", value: 1 },
        { text: "认证成功", value: 2 },
        { text: "认证失败", value: 3 },
    ]
};
